import namespace from "@rdfjs/namespace";
const builder = namespace("http://xmlns.com/foaf/0.1/");
export const strict = builder;
export const loose = builder;
